import { useTranslation } from 'react-i18next';
import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useChatTracking } from '@avanta/shared/hooks/chat/useChatTracking';
import { useMessagesStore } from '@avanta/shared/stores/chat/messages';
import { type OptimisticMessage } from '@avanta/shared/types/chat';
import { ChatUpdateType } from '@avanta/shared/types/tracking';
import { getUserId } from '@avanta/shared/utils/storage';
import { Content } from '..';

export const DeleteMessage = ({ message }: { message: OptimisticMessage }): React.ReactElement => {
  const { deleteMessage } = useMessagesStore();
  const { trackChatMessageUpdated } = useChatTracking();
  const isDeleted = message.deleted;
  const { t } = useTranslation(LOCIZE_NS.CHAT);

  const handleDeleteMessage = async (): Promise<void> => {
    if (!message || isDeleted) return;
    await deleteMessage(message);
    await trackChatMessageUpdated({
      sessionId: message.channelId,
      messageId: message.timetoken,
      senderId: getUserId(),
      updateType: ChatUpdateType.DELETED,
    });
  };

  return (
    <Dialog
      title={t('Chat.Messages.DeleteDialog.heading')}
      description={t('Chat.Messages.DeleteDialog.body')}
      secondaryAction={{
        label: t('Chat.Messages.DeleteDialog.cancel'),
        variant: 'terciary',
      }}
      primaryAction={{
        label: t('Chat.Messages.DeleteDialog.confirm'),
        action: handleDeleteMessage,
        variant: 'terciary',
        className: 'text-red-500 hover:border-red-600 hover:bg-red-100',
      }}
      open
      hideClose
    >
      <p className="p-4 rounded-2xl bg-teal-200 rounded-tr-none">
        <Content message={message} />
      </p>
    </Dialog>
  );
};
